import { Button, ButtonGroup, Card, Dropdown } from "react-bootstrap";

import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { truncate } from "../../utils";

export const OfferingInstaller = ({
	installer,
	isActive,
	submitChangeActiveInstaller,
	openEditInstallerModal,
	openDeleteInstallerModal,
}) => (
	<Card
		className={`offeringInstallerCard ${
			isActive ? "bg-primary text-white" : "bg-light"
		}`}
		data-testid="test-offeringInstallerCard"
	>
		<Card.Body className="p-2">
			<span className="mt-1 ms-1">
				Version: {installer?.version ? installer.version : "xxxxxxx"}
			</span>
			<Dropdown as={ButtonGroup} className="float-end">
				<Dropdown.Toggle
					as={Button}
					split
					variant="link"
					className="text-dark p-0 m-0 "
				>
					<span className="icon icon-sm">
						<FontAwesomeIcon icon={faCog} className="icon-dark" />
					</span>
				</Dropdown.Toggle>
				<Dropdown.Menu className="text-dark">
					{isActive ? (
						<Dropdown.Item
							onClick={() => submitChangeActiveInstaller(0)}
							className="p-1 ps-2"
						>
							Clear Active
						</Dropdown.Item>
					) : (
						<Dropdown.Item
							onClick={() =>
								submitChangeActiveInstaller(installer.id)
							}
							className="p-1 ps-2"
						>
							Set Active
						</Dropdown.Item>
					)}
					<Dropdown.Item
						onClick={() => openEditInstallerModal(installer)}
						className="p-1 ps-2"
					>
						Edit
					</Dropdown.Item>
					<Dropdown.Item
						onClick={() => openDeleteInstallerModal(installer)}
						className="p-1 ps-2"
					>
						Delete
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
			<div className="mt-1 ms-1">
				File URI:{" "}
				{installer?.fileUri ? (
					<a
						className={`ellipsis ${
							isActive ? "text-gray-500" : "text-primary"
						}`}
						href={installer.fileUri}
					>
						{truncate(installer?.fileUri.split("/").pop(), 15)}
					</a>
				) : (
					"xxxxxxxxxxx"
				)}
			</div>
			<div className="mt-1 ms-1">{installer?.description}</div>
		</Card.Body>
	</Card>
);
